import {
  Directive,
  HostListener,
  ElementRef,
  AfterViewInit
} from '@angular/core';

@Directive({
  selector: '[appPositionAwareCover]'
})

export class PositionAwareCoverDirective implements AfterViewInit {
  overlay: HTMLDivElement;
  button: HTMLDivElement;

  constructor(
    private element: ElementRef
  ) { }

  ngAfterViewInit(): void {
    this.overlay = this.element.nativeElement.children[0];
    this.button = this.element.nativeElement.children[1];
  }

  @HostListener('mouseenter', ['$event'])
  onmouseenter($event: MouseEvent): void {
    const eX = $event.offsetX;
    const eY = $event.offsetY;
    this.button.style.left = this.overlay.style.left = eX + 'px';
    this.button.style.top = this.overlay.style.top = eY + 'px';
  }

  @HostListener('mouseleave', ['$event'])
  onmouseleave($event: MouseEvent): void {
    const eX = $event.offsetX;
    const eY = $event.offsetY;
    this.button.style.left = this.overlay.style.left = eX + 'px';
    this.button.style.top = this.overlay.style.top = eY + 'px';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/position-aware-cover.directive.ts